module.exports = __webpack_public_path__ + "static/artist-development-hero-mobile-ddc7001e1fe82f3ff566dd7cf37bd6cb.png";